export default __webpack_public_path__ + "static/media/ppt2_intro.65179ccb.png";